import SettingConfig from '@module/config/setting';

/** 채팅 번역 실패 토스트 고정 id — 연속 실패 시 토스트가 쌓이지 않고 하나로 합쳐(갱신)진다. */
export const CHAT_TRANSLATE_ERROR_TOAST_ID = 'chat-translate-error';

/**
 * 채팅 번역 실패 안내 문구. 결과(ChatTranslateResult) 자리에 재사용해 표시한다.
 * ko/ja 분기를 한 곳에서 소유해 소비처(패널/fanza)마다 중복하지 않게 한다.
 */
export const getTranslateErrorText = () =>
  SettingConfig.LANG !== 'ko' ? '翻訳リクエストに失敗しました。' : '번역 요청에 실패했습니다.';
